"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Bar_Chart = void 0;

var d3 = void 0;
var nvd3 = void 0;
var hasProp = {}.hasOwnProperty;

Bar_Chart = require("./bar_chart").default;

d3 = require("d3");

nvd3 = require("nvd3");

var Royalties = function Royalties() {
  _classCallCheck(this, Royalties);

  var dontEnums = void 0;
  var dontEnumsLength = void 0;
  var graph_hack = void 0;
  var hasDontEnumBug = void 0;
  var j = void 0;
  var key = void 0;
  var _keys = void 0;
  var len = void 0;
  var ref = void 0;

  Array.max = function (array) {
    return Math.max.apply(Math, _toConsumableArray(array));
  };
  Array.min = function (array) {
    return Math.min.apply(Math, _toConsumableArray(array));
  };

  if (!Object.keys) {
    hasDontEnumBug = true;
    dontEnums = ["toString", "toLocaleString", "valueOf", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "constructor"];
    dontEnumsLength = dontEnums.length;
    ref = {
      toString: null
    };
    for (j = 0, len = ref.length; j < len; j++) {
      key = ref[j];
      hasDontEnumBug = false;
    }
    Object.keys = _keys = function keys(object) {
      var dontEnum = void 0;
      var i = void 0;
      var ii = void 0;
      var name = void 0;
      if ((typeof object === "undefined" ? "undefined" : _typeof(object)) !== "object" && typeof object !== "function" || object === null) {
        throw new TypeError("Object.keys called on a non-object");
      }
      _keys = [];
      for (name in object) {
        if (owns(object, name)) {
          _keys.push(name);
        }
      }
      if (hasDontEnumBug) {
        i = 0;
        ii = dontEnumsLength;
        while (i < ii) {
          dontEnum = dontEnums[i];
          if (owns(object, dontEnum)) {
            _keys.push(dontEnum);
          }
          i++;
        }
      }
      return _keys;
    };
  }
  graph_hack = function graph_hack() {
    $(".tick text").attr("dy", "24px");
    return $(".nv-bar text").attr("dy", "-12px");
  };

  var bar_chart = function (_Bar_Chart) {
    _inherits(bar_chart, _Bar_Chart);

    function bar_chart() {
      _classCallCheck(this, bar_chart);

      return _possibleConstructorReturn(this, (bar_chart.__proto__ || Object.getPrototypeOf(bar_chart)).apply(this, arguments));
    }

    _createClass(bar_chart, [{
      key: "render",
      value: function render(data, format) {
        var graph = void 0;
        graph = this.graph;
        this.remove();
        return nv.addGraph(function () {
          var chart = void 0;
          chart = nv.models.discreteBarChart().x(function (d) {
            return d[0];
          }).y(function (d) {
            return d[1];
          }).staggerLabels(false).tooltips(false).showValues(true).showYAxis(false).transitionDuration(350).color(d3.scale.ordinal().range(["#4c4c4c"]));
          chart.xAxis.showMaxMin(false).tickFormat(function (d) {
            return d3.time.format(format)(new Date(d));
          });
          chart.tooltipContent(function (key, y, e, _ref) {
            var series = _ref.series;

            data = series.values[y - 1];
            return "<p>$" + e + "</p>";
          });
          chart.valueFormat(d3.format("$,.2f"));
          d3.select(graph).datum(data).transition().duration(500).call(chart);
          return graph_hack();
        });
      }
    }]);

    return bar_chart;
  }(Bar_Chart);

  var stacked_chart = function (_Bar_Chart2) {
    _inherits(stacked_chart, _Bar_Chart2);

    function stacked_chart() {
      _classCallCheck(this, stacked_chart);

      return _possibleConstructorReturn(this, (stacked_chart.__proto__ || Object.getPrototypeOf(stacked_chart)).apply(this, arguments));
    }

    _createClass(stacked_chart, [{
      key: "render",
      value: function render(data, format) {
        var graph = void 0;
        graph = this.graph;
        this.remove();
        return nv.addGraph(function () {
          var chart = void 0;
          chart = nv.models.multiBarChart();
          chart.xAxis.showMaxMin(false).tickFormat(function (d) {
            return d3.time.format(format)(new Date(d));
          });
          chart.tooltipContent(function (key, y, e, _ref2) {
            var series = _ref2.series;

            data = series.values[y - 1];
            return "<p>$" + e + "  from " + key + "</p>";
          });
          chart.reduceXTicks(false);
          chart.tooltips(true);
          chart.showLegend(true);
          chart.showYAxis(false);
          chart.multibar.stacked(true);
          chart.showControls(false);
          chart.yAxis.tickFormat(d3.format(",.2f"));
          d3.select("#royalty-graph svg").datum(data).transition().duration(500).call(chart);
          graph_hack();
          return $("body").on("click", ".nv-series", function (e) {
            return graph_hack();
          });
        });
      }
    }]);

    return stacked_chart;
  }(Bar_Chart);

  $("document").ready(function () {
    var $back = void 0;
    var $current_year = void 0;
    var $forward = void 0;
    var $graph_btns = void 0;
    var $no_data = void 0;
    var $svg = void 0;
    var ar = void 0;
    var current_graph = void 0;
    var data = void 0;
    var if_no_data_show_message = void 0;
    var json = void 0;
    var least_recent_year = void 0;
    var most_recent_year = void 0;
    var this_year = void 0;
    $svg = $("#royalty-graph svg");
    $no_data = $(".no-data-message");
    json = $("#graph-data").data("royalties-json");
    $current_year = $("#current-year");
    $forward = $("#forward");
    $back = $("#back");
    this_year = $current_year.data("year");
    $graph_btns = $("#buttonList li");
    current_graph = "stacked";
    ar = Object.keys(json);
    least_recent_year = Array.min(ar);
    most_recent_year = Array.max(ar);
    if_no_data_show_message = function if_no_data_show_message() {
      if (this_year === 2012 || this_year === 2013) {
        if (current_graph === "stacked") {
          $svg.hide();
          return $no_data.removeClass("hidden");
        } else {
          $svg.show();
          return $no_data.addClass("hidden");
        }
      } else {
        $svg.show();
        return $no_data.addClass("hidden");
      }
    };
    $("#buttonList").on("click", "a", function (e) {
      var $parent = void 0;
      var $sibling = void 0;
      var $this = void 0;
      e.preventDefault();
      $this = $(this);
      $parent = $this.parent();
      $sibling = $parent.siblings();
      this_year = $("#current-year").data("year");
      switch ($this.prop("id")) {
        case "total-earned":
          $parent.addClass("active");
          $sibling.removeClass("active");
          current_graph = "stacked";
          if_no_data_show_message();
          return new stacked_chart("#royalty-graph svg", data(this_year, "earned"), "%b");
        case "total-paid":
          $parent.addClass("active");
          $sibling.removeClass("active");
          current_graph = "bar";
          if_no_data_show_message();
          return new bar_chart("#royalty-graph svg", data(this_year, "paid"), "%b");
      }
    });

    $("#year-selection").on("click", "a", function (e) {
      var $this = void 0;
      e.preventDefault();
      $this = $(this);
      switch ($this.prop("id")) {
        case "back":
          this_year = this_year - 1;
          $current_year.html(this_year);
          $current_year.data("year", this_year);
          break;
        case "forward":
          this_year = this_year + 1;
          $current_year.html(this_year);
          $current_year.data("year", this_year);
      }
      if (this_year !== most_recent_year) {
        $forward.removeClass("disabled");
      }
      if (this_year === most_recent_year) {
        $forward.addClass("disabled");
      }
      if (this_year !== least_recent_year) {
        $back.removeClass("disabled");
      }
      if (this_year === least_recent_year) {
        $back.addClass("disabled");
      }
      if_no_data_show_message();
      switch (current_graph) {
        case "stacked":
          return new stacked_chart("#royalty-graph svg", data(this_year, "earned"), "%b");
        case "bar":
          return new bar_chart("#royalty-graph svg", data(this_year, "paid"), "%b");
      }
    });

    data = function data(year, type) {
      var api = void 0;
      var api_array = void 0;
      var current_year = void 0;
      var i = void 0;
      var paid = void 0;
      var purchase = void 0;
      var purchased_array = void 0;
      var royalty_array = void 0;
      var sub = void 0;
      var sub_array = void 0;
      i = 0;
      sub_array = [];
      purchased_array = [];
      api_array = [];
      royalty_array = [];
      current_year = json[year];
      while (i < current_year.length) {
        if (current_year[i].total_earned !== void 0) {
          sub_array.push({
            x: new Date(current_year[i].date),
            y: parseFloat(current_year[i].subscription.total)
          });
          purchased_array.push({
            x: new Date(current_year[i].date),
            y: parseFloat(current_year[i].purchased.total)
          });
          api_array.push({
            x: new Date(current_year[i].date),
            y: parseFloat(current_year[i].api.total)
          });
          royalty_array.push([new Date(current_year[i].date), parseFloat(current_year[i].total_paid)]);
        } else {
          royalty_array.push([new Date(current_year[i].date), parseFloat(current_year[i].total_paid)]);
        }
        i++;
      }
      paid = {};
      sub = {};
      purchase = {};
      api = {};
      paid.key = "Paid";
      sub.key = "Subscription";
      purchase.key = "Purchased";
      api.key = "API";
      sub.color = "#3EA9F5";
      purchase.color = "#7AC943";
      api.color = "#1A1A1A";
      paid.values = royalty_array;
      sub.values = sub_array;
      purchase.values = purchased_array;
      api.values = api_array;
      if (type === "earned") {
        return [sub, purchase, api];
      } else {
        return [paid];
      }
    };

    return new stacked_chart("#royalty-graph svg", data(this_year, "earned"), "%b");
  });

  $("body").on("click", "#sack", function (e) {
    e.preventDefault();
    $("#cash img").toggleClass("ooooh-coins");
    return setTimeout(function () {
      return $("#cash img").removeClass("ooooh-coins");
    }, 1000);
  });

  $("body").on("click", "#cash img.ooooh-coins", function (e) {

    return $(this).clone().appendTo("#for-keeps");
  });
};

exports.default = Royalties;